<template>
  <div>
    <GroupIntro :group="group" :joinBtnVisible="joinBtnVisible" :joinBtnDisabled="joinBtnDisabled" />
  </div>
</template>
<script>
import GroupIntro from "@/components/molecules/GroupIntro";

export default {
  name: "LeftSideBarGroup",
  props: ["group", "joinBtnVisible", "joinBtnDisabled"],
  components: {
    GroupIntro,
  },
};
</script>
